export default {
	NOT_LOADING: "NOT_LOADING",
	LOADING: "LOADING",
	ERROR: "ERROR",
	SUCCESS: "SUCCESS",
	ACTION_START_LOADING: "START_LOADING",
	ACTION_END_LOADING: "END_LOADING",
	ACTION_LOADING_SUCCESS: "LOADING_SUCCESS",
	ACTION_SET_ERROR: "SET_ERROR",
	ACTION_RESET_ERROR: "RESET_ERROR",
}